import { CommonModule } from '@angular/common';
import { Component, Output , Input, ViewEncapsulation, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, FormsModule , NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';


@Component({
  selector: 'app-input',
  imports: [MatInputModule,FormsModule,ReactiveFormsModule,MatSelectModule,CommonModule],
  templateUrl: './input.html',
  styleUrl: './input.scss',
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> InputComponent),
      multi:true
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class InputComponent implements ControlValueAccessor{
  @Input() type : string = ''
  @Input() label : string = ''
  @Input() field : any = null;
  @Input() errorMessage : string = '';
  @Input() formControl!: FormControl;
  @Input() value: any = null;

  onChangeCb?: (value:any) => void;

  checkbox:boolean = false;
  onTouchedcb?: () =>void;
  writeValue(event: Event): void {
    this.value = event;
  }
  registerOnChange(value:any): void {
    this.onChangeCb = value;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedcb = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error('Method not implemented.');
  }
  @Output () inputValue = new EventEmitter<any>();
  setValue(event:Event){
    const value = (event.target as HTMLInputElement).value;
    this.value = value;
    this.onChangeCb?.(value);
    this.inputValue.emit(value);
  }

}
